

/*
  Sajith Henarath
 */

export class StudioSearchModel {

  public constructor(init? : Partial<StudioSearchModel>) {
    Object.assign(this, init);
    this.dateRange = [];
  }

  dateRange: string[];
  referenceNumber: string;
  name: string;
  phoneNumber: string;
  birthDate: string;
  appType: string;
}
